import React from 'react';
import { 
  MapPin, 
  Phone, 
  Mail, 
  Facebook,  
  MessageCircle,
  ArrowRight
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = ({ currentView, setCurrentView }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const navigationItems = [
  { id: 'inicio', name: 'Inicio' },
  { id: 'marcas', name: 'Nuestras Marcas',
    subItems: [
      { id: 'recetario', name: 'Recetario' }
    ]
  },
  { id: 'clientes', name: 'Socios Comerciales' },
  { id: 'maquiladoras', name: 'Maquiladoras' },
  // { id: 'noticias', name: 'Noticias'},
  // { id: 'eventos', name: 'Eventos'},
  { id: 'trabajo', name: 'Únete al equipo' },
  { id: 'contacto', name: 'Contacto' },
  { id: 'politica', name: 'Políticas' },
  { id: 'quejas', name: 'Quejas y Sugerencias' }
];

  const socialLinks = [
    { 
      name: 'Facebook', 
      url: 'https://www.facebook.com/campo.fresco.33?rdid=KTlKvk1utUjp77ex&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1RYzwLjBDs%2F#', 
      icon: Facebook,
      color: 'hover:bg-blue-600'
    },
   
    // { 
    //   name: 'WhatsApp', 
    //   url: 'https://wa.me/+5214626218268', 
    //   icon: MessageCircle,
    //   color: 'hover:bg-green-600' 
    // }
  ];


  const handleSectionClick = (sectionId) => {
    // Navegar a la nueva ruta
    if (sectionId === 'inicio') {
      navigate('/');
    } else {
      navigate(`/${sectionId}`);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-green-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 relative z-10">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-6">
          
          {/* Column 1: Brand & Description */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <h3 className="text-2xl font-bold bg-gradient-to-r from-green-400 to-green-600 bg-clip-text text-transparent">
                CAMPO FRESCO
              </h3>
              <p className="text-gray-300 text-base leading-relaxed mt-2 max-w-md">
                Los mejores granos y semillas directo en tu mesa. 
                Comprometidos con la calidad y la satisfacción de nuestros clientes.
              </p>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-base font-semibold mb-3 flex items-center space-x-2">
                <span>Síguenos</span>
                <ArrowRight className="w-3.5 h-3.5 text-green-400" />
              </h4>
              <div className="flex space-x-2.5">
                {socialLinks.map((social) => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`w-10 h-10 bg-gray-800/80 backdrop-blur-sm ${social.color} rounded-lg flex items-center justify-center transition-all duration-300 group hover:scale-110 hover:shadow-md`}
                      aria-label={`Visitar nuestro ${social.name}`}
                    >
                      <IconComponent className="w-4 h-4 group-hover:scale-110 transition-transform duration-300" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>          {/* Column 2: Navigation */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400 flex items-center space-x-2">
               <span>Navegación</span>
              <div className="w-6 h-0.5 bg-gradient-to-r from-green-400 to-transparent"></div>
            </h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {navigationItems.map((item) => (
                <button 
                  key={item.id}
                  onClick={() => handleSectionClick(item.id)}
                  className={`flex items-center space-x-1.5 text-sm text-gray-300 hover:text-white transition-all duration-300 group text-left w-full ${
                    currentView === item.id ? 'text-green-400 font-semibold' : ''
                  }`}
                >
                  <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform duration-300 opacity-50" />
                  <span className="group-hover:translate-x-0.5 transition-transform duration-300">
                    {item.name}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Column 3: Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400 flex items-center space-x-2">
              <span>Contacto</span>
              <div className="w-6 h-0.5 bg-gradient-to-r from-green-400 to-transparent"></div>
            </h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-2.5 group">
                <div className="bg-green-500/20 p-1.5 rounded-md group-hover:bg-green-500/30 transition-colors duration-300">
                  <MapPin className="w-4 h-4 text-green-400" />
                </div>
                <div>
                  <p className="text-gray-300 text-xs leading-relaxed">
                    Planta Campo Fresco<br />
                    Carretera Irapuato - Silao km 45, No. 12357<br />
                    La Calera
                  </p>
                </div>
              </div>
              
              {/* <div className="flex items-center space-x-2.5 group">
                <div className="bg-green-500/20 p-1.5 rounded-md group-hover:bg-green-500/30 transition-colors duration-300">
                  <Phone className="w-4 h-4 text-green-400" />
                </div>
                <a 
                  href="tel:+5214621234567" 
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-medium"
                >
                  +52 (462) 123-4567
                </a>
              </div> */}
              
              <div className="flex items-center space-x-2.5 group">
                <div className="bg-green-500/20 p-1.5 rounded-md group-hover:bg-green-500/30 transition-colors duration-300">
                  <Mail className="w-4 h-4 text-green-400" />
                </div>
                <a 
                  href="mailto:contacto@campofresco.com.mx" 
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-medium"
                >
                  contacto@campofresco.com.mx
                </a>
              </div>
            </div>
          </div> 

          {/* Copyright notice correctly placed as a direct child of the grid */}
          <div className="lg:col-span-4 md:col-span-2 text-center pt-6 mt-4 border-t border-gray-700/50">
              <p className="text-gray-400 text-xs">
                &copy; {currentYear} Campo Fresco. Todos los derechos reservados.
              </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;